import type {Callback, CompRef, Pointer, PS} from '@wix/document-services-types'

const onComponentsScroll = (ps: PS, callback: Callback) => ps.siteAPI.setOnComponentsScrollListener(callback)

const scroll = (ps: PS, componentPointer: Pointer, x: number, y: number, callback: Function) =>
    ps.siteAPI.scroll(componentPointer, x, y, callback)

const scrollBy = (ps: PS, componentPointer: Pointer, x: number, y: number, callback: Function) =>
    ps.siteAPI.scrollBy(componentPointer, x, y, callback)

const getTotalScrolls = (ps: PS, componentPointer: Pointer) => ps.siteAPI.getTotalScroll(componentPointer)

const isScrollable = (ps: PS, componentPointer: CompRef) => ps.extensionAPI.viewer.isScrollable(componentPointer)

export default {
    onComponentsScroll,
    isScrollable,
    scroll,
    scrollBy,
    getTotalScrolls
}
